var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    _vm.order.sub_orders.find(
      item => item.status === 'shipping' || item.status === 'confirmed'
    ) && _vm.order.order.status === 'paid'
  )?_c('span',[_c('a',{on:{"click":_vm.onAddRefundOrder}},[_vm._v("添加售后单")]),_c('a-modal',{attrs:{"title":"添加售后单","visible":_vm.visible,"confirm-loading":_vm.lodaing},on:{"ok":_vm.onOk,"cancel":function($event){_vm.visible = false}}},[_c('a-form',{staticClass:"form",attrs:{"form":_vm.form}},[_c('a-form-item',{attrs:{"label":"退款金额"}},[_c('a-input-number',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'amount',
            {
              initialValue: 0,
              rules: [{ required: true, message: '请输入退款金额！' }]
            }
          ]),expression:"[\n            'amount',\n            {\n              initialValue: 0,\n              rules: [{ required: true, message: '请输入退款金额！' }]\n            }\n          ]"}],staticStyle:{"width":"100%"},attrs:{"min":0,"precision":2}})],1),_c('a-form-item',{attrs:{"label":"备注"}},[_c('a-textarea',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'remark',
            {
              rules: [
                { required: true, message: '请备注退款原因、快递信息等！' },
                { max: 600, message: '请输入最多 600 个字符！' }
              ]
            }
          ]),expression:"[\n            'remark',\n            {\n              rules: [\n                { required: true, message: '请备注退款原因、快递信息等！' },\n                { max: 600, message: '请输入最多 600 个字符！' }\n              ]\n            }\n          ]"}],staticStyle:{"width":"100%"},attrs:{"placeholder":"请备注退款原因、快递信息等","auto-size":{ minRows: 5, maxRows: 15 }}})],1)],1)],1),_c('a-divider',{attrs:{"type":"vertical"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }